type FeatureFlagKeys =
  | 'imageEditor'
  | 'iframeGenerator'
  | 'aiTranslations'
  | 'adminPanel'
  | 'aiAssistant'
  | 'landingPages'

const featureFlags: Record<FeatureFlagKeys, boolean> = {
  imageEditor: import.meta.env.REACT_APP_FEATURE_IMAGE_EDITOR === 'true',
  iframeGenerator: import.meta.env.REACT_APP_FEATURE_IFRAME === 'true',
  aiTranslations: import.meta.env.REACT_APP_FEATURE_AI_TRANSLATIONS === 'true',
  adminPanel: import.meta.env.REACT_APP_FEATURE_ADMIN_PANEL === 'true',
  aiAssistant: import.meta.env.REACT_APP_FEATURE_AI_ASSISTANT === 'true',
  landingPages: import.meta.env.REACT_APP_FEATURE_LANDING_PAGES === 'true'
}

export function useFeatureFlag(flagName: FeatureFlagKeys): boolean {
  return !!featureFlags[flagName]
}
